// Helper function to extract error message from API responses
export const getErrorMessage = (error, defaultMessage = 'Ha ocurrido un error') => {
  if (!error.response?.data) {
    return error.message || defaultMessage;
  }
  
  const data = error.response.data;
  
  // String detail
  if (typeof data.detail === 'string') {
    return data.detail;
  }
  
  // Pydantic validation errors (array of objects)
  if (Array.isArray(data.detail)) {
    return data.detail
      .map(e => e.msg || e.message || 'Error de validación')
      .join(', ');
  }
  
  // Object detail
  if (typeof data.detail === 'object' && data.detail !== null) {
    return data.detail.msg || data.detail.message || JSON.stringify(data.detail);
  }
  
  // Plain string response
  if (typeof data === 'string') {
    return data;
  }
  
  // Message field
  if (data.message) {
    return data.message;
  }
  
  return defaultMessage;
};
